import serverCall from "../serverCall";

const getPerformance = (gameName, period, playerId) => {
  try {
    const response = serverCall.get(
      `/scores/progression/wiseData?period=${period}&gameName=${gameName}&playerId=${playerId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getScores = (gameName, period, playerId, filterType) => {
  try {
    const response = serverCall.get(
      `/scores/scoreWise/filterData?period=${period}&filterType=${filterType}&gameName=${gameName}&playerId=${playerId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getPlayerByUser = () => {
  try {
    const response = serverCall.get(`/player/getPlayerByUser`);
    return response;
  } catch (error) {
    throw error;
  }
};

let gamesCache = null;
let gamesPromise = null;

const getGames = () => {
  try {
    if (gamesCache) {
      return Promise.resolve(gamesCache);
    }

    if (gamesPromise) {
      return gamesPromise;
    }

    gamesPromise = serverCall
      .get(`/game`)
      .then((response) => {
        gamesCache = response;
        return response;
      })
      .finally(() => {
        gamesPromise = null;
      });

    return gamesPromise;
  } catch (error) {
    throw error;
  }
};

const getMilestones = () => {
  try {
    const response = serverCall.post(
      `/scores/milestones/userGame/unlockPolicies`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const PerformanceService = {
  getPerformance,
  getPlayerByUser,
  getGames,
  getScores,
  getMilestones,
};

export default PerformanceService;
